<div class="specialties-discounts-page">

    <!-- ==========================================
       ENCABEZADO
  =========================================== -->
    <div class="page-header">

        <h1>
            Especialidades y Descuentos
        </h1>

    </div>


    <!-- ==========================================
       TABS
  =========================================== -->
    <div class="page-tabs">

        <!-- ESPECIALIDADES -->
        <button type="button" class="page-tab" [class.active]="activeTab === 'especialidades'"
            (click)="setActiveTab('especialidades')">

            <span>Especialidades</span>

            <span class="tab-counter" [class.active]="activeTab === 'especialidades'">
                {{ cantidadEspecialidades }}
            </span>

        </button>


        <!-- DESCUENTOS -->
        <button type="button" class="page-tab" [class.active]="activeTab === 'descuentos'"
            (click)="setActiveTab('descuentos')">

            <span>Cupones de descuento</span>

            <span class="tab-counter" [class.active]="activeTab === 'descuentos'">
                {{ cantidadDescuentos }}
            </span>

        </button>

    </div>


    <!-- ==========================================
       CONTENIDO DE LOS TABS
  =========================================== -->
    <div class="page-tab-content">

        <!-- COMPONENTE ESPECIALIDADES -->
        <app-admin-especialidades *ngIf="activeTab === 'especialidades'"
            (cantidadEspecialidadesChange)="onCantidadEspecialidadesChange($event)">
        </app-admin-especialidades>


        <!-- COMPONENTE DESCUENTOS -->
        <app-admin-descuentos *ngIf="activeTab === 'descuentos'"
            (cantidadDescuentosChange)="onCantidadDescuentosChange($event)">
        </app-admin-descuentos>

    </div>

</div>